import styled from 'styled-components';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout.js';
import { ColorAddiFontSecondary } from '@addi/foundation/dist/web/colors';
import { Paragraph } from '../typographies';
export const Container = styled.div `
  flex-direction: row;
  display: flex;
  align-items: center;
`;
export const SVGImageIcon = styled.img `
  height: 20px;
  width: 50%;
  padding: 8px 0;
  background-color: ${({ selected }) => (selected ? ColorAddiFontSecondary : 'transparent')};
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    height: 24px;
  }
`;
export const ToggleBox = styled.div `
  cursor: pointer;
  width: 76px;
  height: 36px;
  border: 1px solid ${ColorAddiFontSecondary};
  border-radius: 32px;
  overflow: hidden;
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    width: 96px;
    height: 40px;
  }
`;
export const Label = styled(Paragraph) `
  display: none;
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    display: block;
    font-size: 18px;
    font-weight: 400;
    line-height: 26.64px;
    padding-right: 12px;
  }
`;
//# sourceMappingURL=order-selector.styled.js.map